import { lazy } from "react";

const Home = lazy(() => import(/*webpackChunkName:'App/Home' */'../pages/home.page'));
const PortfolioPage = lazy(() => import(/*webpackChunkName:'App/PortfolioPage' */'../pages/portfolio.page'));
const ProjectDetails = lazy(() => import(/*webpackChunkName:'App/ProjectDetails' */'../pages/project.page'));
const ContactPage = lazy(() => import(/*webpackChunkName:'App/ContactPage' */'../pages/contact.page'));
const AboutPage = lazy(() => import(/*webpackChunkName:'App/AboutPage' */'../pages/about.page'));
const BlogsPage = lazy(() => import(/*webpackChunkName:'App/BlogsPage' */'../pages/blogs.page'));
const ServicesPage = lazy(() => import(/*webpackChunkName:'App/ServicesPage' */'../pages/services.page'));

const NotFound = lazy(() => import(/*webpackChunkName:'App/404' */'../pages/notFound'));

const routes = [
    { path: ['/', '/home'], exact: true, component: Home },
    { path: ['/portfolio', '/projects'], exact: true, component: PortfolioPage },
    { path: '/project/:slug', exact: true, component: ProjectDetails },
    { path: '/contact', exact: true, component: ContactPage },
    { path: '/about', exact: true, component: AboutPage },
    { path: '/blogs', exact: true, component: BlogsPage },
    { path: '/blog', exact: true, component: BlogsPage },
    { path: '/services', exact: true, component: ServicesPage },
    { path: '*', exact: true, component: NotFound },
];

export default routes;